import React, {FC} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {schemaOrderLaundry} from '../../../../../util/validationLavanderia'
import {LaundryModel} from '../../../model'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ContainerWrapper from '../../componentes/Container'
import {TabLavanderiaModel} from '../../../../../models'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {createLaundry, updateLaundry} from '../../../services'

import {renderPanelContent} from '../components'
import {getUTCDate} from '../../../util/functions'
import {ShowSnackBar} from '../../../../../util/functions'

const LaundryReceptionPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const methods = useForm<LaundryModel>({
    resolver: yupResolver(schemaOrderLaundry),
  })
  const {reset} = methods

  const onSubmit = async (data: LaundryModel) => {
    data.campoadicionalnum1 = Number(data.campoadicionalnum1)
    data.campoadicionalnum2 = Number(data.campoadicionalnum2)
    data.campoadicionalnum3 = Number(data.campoadicionalnum3)
    if (data.campoadicionalFec1) {
      const fechaLocal = new Date(data.campoadicionalFec1)
      const fechaUTC = getUTCDate(fechaLocal)
      data.campoadicionalFec1 = fechaUTC.toISOString()
    }

    if (data.campoadicionalFec2) {
      const fechaLocal2 = new Date(data.campoadicionalFec2)
      const fechaUTC2 = getUTCDate(fechaLocal2)
      data.campoadicionalFec2 = fechaUTC2.toISOString()
    }

    if (currentTabItem.idToEdit) {
      data.id = currentTabItem.idToEdit
      const response = await updateLaundry(data)
      if (!response.data.error) {
        reset()

        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-laundry',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar('Se actualizó el registro correctamente')
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    } else {
      const response = await createLaundry(data)
      if (!response.data.error) {
        reset()
        ShowSnackBar('Se creó con éxito')
        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-laundry',
          },
        }
        changeCurrentTabItem(obj)
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default LaundryReceptionPageWrapper
